import { useApi } from '@/composables/useApi'

const api = useApi()

const getGrupoUsuarioById = (idGrupoUsuario, TypeDate = '') => new Promise((resolve, reject) => {
  try {
    const params = TypeDate !== null ? TypeDate : {}
    api.get(`/groups/${idGrupoUsuario}`, {
      params,
    })
      .then(res => {
        resolve(res.data)
      })
  } catch (error) {
    reject(error)
  }
})

const deletedGrupoUsuarioById = idGrupoUsuario => new Promise((resolve, reject) => {
  try {
    api.delete(`/groups/${idGrupoUsuario}`)
      .then(res => {
        resolve(res.data)
      })
  } catch (error) {
    reject(error)
  }
})

export {
  getGrupoUsuarioById,
  deletedGrupoUsuarioById,
}
